import {Reservation, Status} from '@wix/ambassador-table-reservations-v1-reservation/types'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'

export const isReservationSuccessful = (reservation: Reservation) => {
  return reservation.status === Status.RESERVED || reservation.status === Status.REQUESTED
}

export const getRefererFromUrlParams = (flowAPI: ControllerFlowAPI): string | undefined => {
  const urlParams = flowAPI.controllerConfig?.wixCodeApi?.location?.query ?? {}
  const utmSource = urlParams.utmSource
  const utmMedium = urlParams.utmMedium

  if (utmSource === 'google' && utmMedium === 'reserve_button') {
    return 'google_reserve_button'
  }

  return undefined
}
